import { Grid, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import EmptyLiveMonitoringFilter from "../filters/EmptyLiveMonitoringFilter";

function EmptyLiveMonitoring() {
    const { t } = useTranslation("finance", { keyPrefix: 'cashback' });

    return (
        <Stack direction={"column"} spacing={2} margin={"16px"}>
            <EmptyLiveMonitoringFilter />
            <Grid container direction="column" alignItems="center" justifyContent="center" style={{ minHeight: '50vh' }}
                spacing={0}>

                <Typography variant={'h5'} fontWeight={"bold"} color={"primary"} align="center">
                    {t('livemonitoring.form.empty-title')}
                </Typography>
                <Typography variant={'body1'} color={"grey"} component="div">
                    {t('livemonitoring.form.empty-body')}
                </Typography>

            </Grid>
        </Stack>
    )
}

export default EmptyLiveMonitoring;